import { ActionTree } from 'vuex';
import { QueryState } from './types';
import { RootState } from '../types';
import { parse } from 'qs';

export const actions: ActionTree<QueryState, RootState> = {
  fetchQuery({ commit }): any {
    const queryString = document.location.href.split('?')[1];

    if (queryString) {
      const query: QueryState = (parse(queryString) as unknown) as QueryState;

      query.checkInDate = new Date(query.checkInDate);
      query.checkOutDate = new Date(query.checkOutDate);

      if (typeof query.adults !== 'undefined') Number(query.adults);
      if (query.children) {
        query.children = Array.isArray(query.children)
          ? query.children.map((child: any) => Number(child))
          : [Number(query.children)];
      }

      commit('updateQuery', query);
    }
  },
};
